<template>
  <validation-observer v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('fourthStepAvailable', $event)" />

    <v-row class="mx-auto">
      <v-col id="saneamento-voc-aplicar-caderno-servicos" cols="12" class="pl-2 pt-0">
        <v-checkbox v-model="_campos.aplicarCadernoServicos" label="Aplicar Caderno de Serviços nas obras" />
      </v-col>
    </v-row>

    <template v-if="_campos.aplicarCadernoServicos === true">
      <saneamento-voc-choose-paramentros-com-ca
        divId="saneamento-caderno-servicos"
        titulo="Caderno de Materiais e Serviços"
        nomeParametro="Caderno de Serviços"
        :items="cadernosServicosExistentes"
        :campos.sync="_campos"
        linkCadastros="/parametros-com-ca/cadernos-servicos"
        parametro="cadernoServico"
      >
        <template v-if="_campos.cadernoServico.origem === 'novo'" v-slot:after-title>
          <v-alert dense outlined type="info" color="blue" class="pa-2">
            <a @click="$router.push('/parametros-com-ca/modelos-cadernos-servicos')">Clique aqui</a>
            para criar e baixar um modelo do sistema. Edite, salve como .CSV e envie.
            <br />
            <b>Atenção:</b>
            Esta ação abrirá uma nova página e informações não salvas serão perdidas.
          </v-alert>
        </template>
      </saneamento-voc-choose-paramentros-com-ca>

      <v-row id="saneamento-voc-percentuais-padroes" class="mx-auto">
        <v-col cols="12">
          <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">Percentuais Padrão</span>
        </v-col>

        <v-col v-for="(campoPercentual, _key) in _campos.camposPercentuaisPadroes" :key="_key" cols="6" sm="4">
          <v-text-field
            v-model="campoPercentual.value"
            :label="campoPercentual.label"
            type="number"
            min="0"
            max="1"
            step="0.1"
            hint="Valor entre 0 (0%) e 1 (100%)"
            outlined
            @blur="
              campoPercentual.value > 1 ? (campoPercentual.value = 1) : true;
              campoPercentual.value < 0 ? (campoPercentual.value = 0) : true;
            "
          />
        </v-col>
      </v-row>
    </template>
  </validation-observer>
</template>

<script>
  export default {
    name: 'SaneamentoVocThirdWizardTab',

    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue'),
      SaneamentoVocChooseParamentrosComCa: () => import('@/components/saneamentoVoc/SaneamentoVocChooseParamentrosComCa.vue')
    },

    props: {
      campos: {
        type: Object,
        required: true
      },
      cadernosServicosExistentes: {
        type: Array,
        required: true
      },
      filtros: {
        type: Object,
        required: true
      }
    },

    emits: ['fourthStepAvailable', 'update:campos'],

    data() {
      return {
        processandoArquivoModelo: false
      };
    },

    computed: {
      _campos: {
        get() {
          return this.campos;
        },
        set(newValues) {
          this.$emit('update:campos', newValues);
        }
      }
    }
  };
</script>

<style></style>
